module.exports = __webpack_public_path__ + "img/label-icon.1dc01b17.png";